import type { InitData } from './types'

export function useInitData(): Readonly<Ref<InitData>> {
  const data = useState<InitData>('initData')

  // The initData plugin MUST run before this composable is called.
  if (data.value === null) {
    throw new Error('useInitData composable called before initData plugin.')
  }

  return readonly(data) as Readonly<Ref<InitData>>
}
